import { DueDateType } from '@g2-shared/api-client/generated/settlement-app';

export const DueDateTypeLabelMapper: Record<DueDateType, string> = {
  [DueDateType.PERIODIC_MONTH]: 'Periodic_month',
  [DueDateType.PERIODIC_QUARTER]: 'Periodic_quarter',
  [DueDateType.PERIODIC_WEEKDAYS]: 'Periodic_weekdays',
  [DueDateType.PERIODIC_YEAR]: 'Periodic_year',
  [DueDateType.T_PLUS_N]: 'T_plus_n',
};
